import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CartAdmin, DataTablesList, UserCartReservation } from '@shared/definitions';

@Injectable({
  providedIn: 'root',
})
export class CartApiService {
  constructor(private http: HttpClient) {}

  getAdminCarts = (params?) => this.http.get<DataTablesList<CartAdmin>>('/api/v1.0/carts', { params });

  getAdminCart = (cartId: string) => this.http.get<CartAdmin>(`/api/v1.0/carts/${cartId}`);

  cancelCartHold = (cartId: string) => this.http.post<void>(`/api/v1.0/carts/${cartId}/hold/cancel`, {});

  resendCartHoldConfirmation = (cartId: string) =>
    this.http.post<void>(`/api/v1.0/carts/${cartId}/hold/resend-confirmation`, {});

  // The reservation code is the credential; 400 `reservation_not_found` once the hold is paid or expired.
  printCartHold = (reservationCode: string, context?: HttpContext) =>
    this.http.get(`/api/v1.0/carts/hold/${encodeURIComponent(reservationCode)}/print`, {
      responseType: 'blob',
      ...(context ? { context } : {}),
    });

  getUserReservations = () =>
    this.http.get<UserCartReservation[]>('/api/v1.0/me/carts', {
      params: { on_hold: true, cart_status: ['active', 'paid', 'canceled', 'ordered'] },
    });
}
